import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import CanonicalTag from "@/components/CanonicalTag";

const HaywardADU = () => {
  return (
    <div className="min-h-screen bg-background">
      <CanonicalTag url="https://www.udaadu.com/hayward-adu" />
      <Navigation />
      
      <main className="max-w-6xl mx-auto px-4 py-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-foreground">
            ADU Construction in Hayward, CA
          </h1>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Expert ADU design and construction services in Hayward. Transform your property with a custom accessory dwelling unit.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          <div>
            <h2 className="text-2xl font-semibold mb-4 text-foreground">Why Choose UDA ADU in Hayward?</h2>
            <ul className="space-y-2 text-foreground">
              <li>• Local expertise with Hayward regulations</li>
              <li>• Full-service design and construction</li>
              <li>• Transparent pricing and timeline</li>
              <li>• Quality craftsmanship guaranteed</li>
            </ul>
          </div>
          <div>
            <h2 className="text-2xl font-semibold mb-4 text-foreground">Our Hayward ADU Services</h2>
            <ul className="space-y-2 text-foreground">
              <li>• Custom ADU design</li>
              <li>• Permit assistance</li>
              <li>• Construction management</li>
              <li>• Interior design</li>
            </ul>
          </div>
        </div>

        <div className="text-center">
          <Button asChild size="lg" className="mr-4">
            <Link to="/contact-us">Get Free Consultation</Link>
          </Button>
          <Button asChild variant="outline" size="lg">
            <Link to="/adu-calculator">Calculate ADU Cost</Link>
          </Button>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default HaywardADU;